import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import LandingPageFR from "@/pages/LandingPageFR";
import LandingPageES from "@/pages/LandingPageES";
import { PrivacyPage, TermsPage, RefundsPage } from "@/pages/LegalPages";
import NotFoundPage from "@/pages/NotFoundPage";
import localeRegistry from "@/locales/registry.json";
// Side-effect import: referral.js captures `?via=` at module-evaluation
// time (before this file's own JSX ever renders) — see that file's
// header comment for why it isn't a useEffect.
import "@/lib/referral";

// Locale homepage routes are generated from the registry (three entries
// today: en -> "/", fr -> "/fr/", es -> "/es/"). "/" always resolves to
// the same <LandingPage /> it always has — registry-driven generation
// does not change its path or behavior.
const LOCALE_PAGES = { en: LandingPage, fr: LandingPageFR, es: LandingPageES };

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          {localeRegistry.map((entry) => {
            const Page = LOCALE_PAGES[entry.code];
            return <Route key={entry.code} path={entry.path} element={<Page />} />;
          })}
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/refunds" element={<RefundsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
